import React, { FormEvent, useEffect, useState } from "react";
import CartIcon from "./CartIcon";
import SearchIcon from "./SearchIcon";
import LoggedOutUser from "./LoggedOutUser";
import User from "./User";
import { ModalType}  from "../types";
import { setCookie, getCookie } from "@wantable/Shared/src/utils/cookies";
import Help from "./Help";

export interface DesktopNavProps {
  isLoggedIn: boolean;
  cartItemsAmount: number;
  wishlistItemsAmount: number;
  openedModal: ModalType;
  isMobile: boolean;
  hidden: boolean;
  onAfterLogin?: () => void;
  onLogout: () => void;
  openModal: () => void;
  handleLogin(): void;
}

const DesktopNav = (props: DesktopNavProps) => {
  const [activeMenu, setActiveMenu] = useState(getCookie('menu-selected') || "Womens")

  {/* @ts-ignore */}

  return (
    <nav id='desktop-nav' className={`${props.hidden ? '' : 'hidden'} font-primary bg-white`}>
      <div className="top-nav relative border-b border-grey-200 flex items-center justify-between h-[40px] px-[40px]">
        <div className="flex justify-start font-bold text-[16px]">
          <a data-testid="edits" type="button" className="btn mw-btn text-grey-400 mr-30 leading-loose text-[16px]" href="https://www.wantable.com">EDITS</a>
          <button type="button" data-testid="shop" className="mw-btn text-grey-400 leading-loose active">SHOP</button>
        </div>
        <div className="flex justify-end items-center font-bold text-[12px]">
          <Help isLoggedIn={props.isLoggedIn} />
          <div className="ml-30">
            {props.isLoggedIn ? (
              <User className={"w-20 h-20"} isLoggedIn={props.isLoggedIn} isMobile={props.isMobile} onLogout={props.onLogout} />
            ) : (
              <LoggedOutUser isDesktop={true} onLogin={props.handleLogin} />
            )}
          </div>
        </div>
      </div>
      <div className="mid-nav relative flex items-center justify-between h-[60px] px-[40px]">
        <div className="flex justify-start text-[12px]">
          <button type="button" aria-label="womens menu button" data-testid="womens-menu" onClick={() => setActiveMenu("Womens")} className={`mw-btn text-grey-400 mr-20 ${activeMenu == "Womens" ? 'active' : ''}`}>Women</button>
          <button type="button" aria-label="mens menu button" data-testid="mens-menu" onClick={() => setActiveMenu("Mens")} className={`mw-btn text-grey-400 mr-20 ${activeMenu == "Mens" ? 'active' : ''}`}>Men</button>
        </div>

        <div className="logo">
          <a href="//shop.wantable.com" className="flex relative left-1/4 top-1/2">
            <img className="h-[40px]" src={window.WANTABLE_header.logo} alt="wantable logo" />
          </a>
        </div>

        <div className="icons search flex items-center justify-end h-[40px]">
          <div className="search border-b border-black">
            <div className="flex items-center">
              <label htmlFor="simple-search" className="sr-only">Search</label>
              <div className="relative w-full">
                <input type="text" id="simple-search" name='q' data-testid="search-input" className="p-1" placeholder="Search..." required />
              </div>
              <button type="button" aria-label="Search Icon" className="p-2.5 ml-2 text-sm font-medium text-black focus:ring-4 focus:outline-none">
                <SearchIcon className="w-18 h-18"/>
                <span className="sr-only">Search</span>
              </button>
            </div>
          </div>


          <div className="icon ml-20 flex justify-center items-center relative wk-ref">
          </div>

          <div className="icon ml-20 flex justify-center items-center relative">
            <button name="cart" aria-label="Cart Icon" data-testid="cart-button">
              <div className="cart-icon">
                <CartIcon className="w-24 h-24" />
              </div>
              {props.cartItemsAmount > 0 && (
                <div className="absolute -top-6 -right-6 font-bold text-[12px] core-peach">
                  <span>{props.cartItemsAmount}</span>
                </div>
              )}
            </button>
          </div>
        </div>
      </div>
      <div id="menu-wrapper" className="bot-nav flex items-center justify-center h-[40px] px-[40px]">
      </div>
    </nav>
  )
}

export default DesktopNav
